import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import CircularProgress from 'material-ui/CircularProgress';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import Schedule from 'material-ui/svg-icons/action/schedule';
import ErrorIcon from 'material-ui/svg-icons/alert/error';
import Send from 'material-ui/svg-icons/content/send';

const DELAY_MS = 300;
const STATUS_ICON = { width: 20, height: 20 };

const STATUS_VIEW = {
    pending: { label: 'Pending', kind: 'pending' },
    in_progress: { label: 'In progress', kind: 'progress' },
    starting: { label: 'Starting', kind: 'progress' },
    running: { label: 'Running', kind: 'progress' },
    collecting: { label: 'Collecting', kind: 'progress' },
    done: { label: 'Done', kind: 'done' },
    completed: { label: 'Completed', kind: 'done' },
    failed: { label: 'Failed', kind: 'failed' },
    cancelled: { label: 'Cancelled', kind: 'failed' },
};

export function HoverTip({ label, children }) {
    const anchor = useRef(null);
    const timer = useRef(null);
    const [box, setBox] = useState(null);

    const hide = () => {
        window.clearTimeout(timer.current);
        setBox(null);
    };

    const show = () => {
        window.clearTimeout(timer.current);
        if (!label) {
            return;
        }
        timer.current = window.setTimeout(() => {
            const node = anchor.current;
            if (!node) {
                return;
            }
            const rect = node.getBoundingClientRect();
            const below = rect.top < 40;
            setBox({
                top: below ? rect.bottom + 6 : rect.top - 6,
                left: Math.max(8, rect.left),
                below,
            });
        }, DELAY_MS);
    };

    useEffect(() => {
        if (!box) {
            return undefined;
        }
        window.addEventListener('scroll', hide, true);
        return () => window.removeEventListener('scroll', hide, true);
    }, [box]);

    const bubble = box ? (
        <span
            className="test-runs-tip-bubble"
            role="tooltip"
            style={{
                top: box.top,
                left: box.left,
                transform: box.below ? 'none' : 'translateY(-100%)',
            }}
        >
            {label}
        </span>
    ) : null;

    return (
        <span
            ref={anchor}
            className="test-runs-tip"
            onMouseEnter={show}
            onMouseLeave={hide}
        >
            {children}
            {bubble ? ReactDOM.createPortal(bubble, document.body) : null}
        </span>
    );
}

export function DocStatus({ status }) {
    const view = STATUS_VIEW[status] || STATUS_VIEW.pending;
    let icon = <Schedule color="#9e9e9e" style={STATUS_ICON} />;
    if (view.kind === 'progress') {
        icon = <CircularProgress size={18} thickness={2} />;
    } else if (view.kind === 'done') {
        icon = <CheckCircle color="#2e7d32" style={STATUS_ICON} />;
    } else if (view.kind === 'failed') {
        icon = <ErrorIcon color="#c62828" style={STATUS_ICON} />;
    }
    return (
        <HoverTip label={view.label}>
            <span className="test-runs-doc-status">{icon}</span>
        </HoverTip>
    );
}

export function LetterLink({ sourceMailId }) {
    if (!sourceMailId) {
        return null;
    }
    return (
        <HoverTip label="Open letter">
            <a
                className="test-runs-letter-link"
                href={`/${sourceMailId}`}
                target="_blank"
                rel="noreferrer"
                onClick={(event) => event.stopPropagation()}
            >
                <Send style={{ width: 18, height: 18 }} color="rgba(0, 0, 0, 0.54)" />
            </a>
        </HoverTip>
    );
}



// WEBPACK FOOTER //
// ./app/components/TestRuns/HoverTip.jsx